// extracted by mini-css-extract-plugin
module.exports = {"container":"_16faiz","tag":"_2H2rnE","shine-lines":"u5P6lP"};